import { motion } from "framer-motion";

const CREDENTIALS = [
  "World-class culinary academy",
  "Michelin-starred kitchens — US & Europe",
  "UHNW private service",
];

export default function About({ onNavigate }) {
  return (
    <section
      data-testid="about-section"
      className="px-6 sm:px-12 lg:px-20 py-24 md:py-32 lg:py-40 border-b border-white/10"
    >
      <div className="grid grid-cols-12 gap-10 lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.4 }}
          className="col-span-12 lg:col-span-5 relative"
        >
          <div className="absolute -top-4 -left-4 w-full h-full border border-white/10 pointer-events-none" />
          <img
            data-testid="about-portrait"
            src="/images/chef-portrait.jpeg"
            alt="Chef Oksana O'Donnell in her whites"
            className="relative w-full aspect-[4/5] object-cover object-top"
          />
        </motion.div>

        <div className="col-span-12 lg:col-span-6 lg:col-start-7 lg:pt-8">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1 }}
            className="text-[11px] uppercase tracking-[0.4em] text-[#EAE6DF]/70 mb-6"
          >
            The Chef
          </motion.p>
          <motion.h2
            data-testid="about-heading"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mb-10"
          >
            Oksana O'Donnell
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="space-y-6 text-sm sm:text-base font-light leading-relaxed text-[#F5F5F7]/70 max-w-xl"
          >
            <p>
              <span className="font-serif text-4xl float-left mr-3 mt-1 leading-[0.8] text-[#EAE6DF]">A</span>
              graduate of one of the world's most celebrated culinary institutions, Oksana honed
              her craft in the kitchens of Michelin-starred chefs across the United States and
              Europe — where precision is not a technique, but a temperament.
            </p>
            <p>
              Today she brings that quiet rigor to private residences: sourcing at dawn, composing
              menus around the rhythms of each household, and disappearing before the first guest
              sits down. What remains is only the meal — and the feeling that it could not have
              been otherwise.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, delay: 0.2 }}
            className="mt-14 space-y-0"
          >
            {CREDENTIALS.map((cred) => (
              <div
                key={cred}
                className="border-t border-white/10 last:border-b py-4 text-[11px] uppercase tracking-[0.3em] text-white/50"
              >
                {cred}
              </div>
            ))}
          </motion.div>

          <motion.button
            data-testid="about-inquire-button"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.3 }}
            onClick={() => onNavigate("#inquiry")}
            className="mt-12 border border-white/30 px-8 py-3 text-[11px] uppercase tracking-[0.3em] text-white transition-colors duration-300 hover:bg-white hover:text-[#121212]"
          >
            Inquire
          </motion.button>
        </div>
      </div>
    </section>
  );
}
